import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=7b32869e&scoped=true"
import script from "./Doc.js?vue&type=script&lang=js&external"
export * from "./Doc.js?vue&type=script&lang=js&external"
import style0 from "./Doc.scss?vue&type=style&index=0&id=7b32869e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b32869e",
  null
  
)

export default component.exports